/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.circle-user-filled\":\"Sirkel med en person i\"}");